module.exports = __webpack_public_path__ + "static/adineuePRO-RegularWeb-1cc40b39df3c49682b755b9118cd121f.woff";